import React, { useState, useEffect, useRef } from 'react';
import logo from '../Assets/hostesss for you.png';
import make from '../Assets/Mask group.png';
import { data, Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiGet } from '../ApiUrls';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMenuOpen2, setIsMenuOpen2] = useState(false);
  const [isSearchPopupOpen, setIsSearchPopupOpen] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const menuRef = useRef(null);
  const menuRef2 = useRef(null);
  const searchPopupRef = useRef(null);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsMenuOpen2(false); // Close the second menu if the first menu is toggled
  };

  const toggleMenu2 = () => {
    setIsMenuOpen2(!isMenuOpen2);
    setIsMenuOpen(false); // Close the first menu if the second menu is toggled
  };

  const openSearchPopup = () => {
    setIsSearchPopupOpen(true);
  };

  const closeSearchPopup = () => {
    setIsSearchPopupOpen(false);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
    if (menuRef2.current && !menuRef2.current.contains(event.target)) {
      setIsMenuOpen2(false);
    }
    if (searchPopupRef.current && !searchPopupRef.current.contains(event.target)) {
      setIsSearchPopupOpen(false);
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    navigate(`/allmodal?query=${searchInput}`);
    closeSearchPopup();
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [IsLogin, setsetIsLogin] = useState(false);

  useEffect(() => {
    const dataToken = localStorage.getItem("userToken");
    if (dataToken) {
      setsetIsLogin(true);
    } else {
      setsetIsLogin(false);
    }
  }, []);

  const [IsUser, setIsUser] = useState(false);
  const [IsHostess, setIsHostess] = useState(false);

  useEffect(() => {
    const userType = JSON.parse(localStorage.getItem("userType"));

    if (userType === "User") {
      setIsUser(true);
    }
    if (userType === "Hostess") {
      setIsHostess(true);
    }
  }, []);


  const Logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('userType');
    localStorage.removeItem('userid');
    localStorage.removeItem('userToken');
    toast.success('Logged out successfully!');
    navigate('/');
    window.location.reload();
  };

  const [UserProfile, setUserProfile] = useState({});
  const [HostessProfile, setHostessProfile] = useState({});
  const [IsUploading, setIsUploading] = useState(false);


  const GetUserProfile = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet(`api/user/GetUserProfile`);
      setUserProfile(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  const GetHostessProfile = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet(`api/hostess/GetHostessProfile`);
      setHostessProfile(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };



  useEffect(() => {
    if (IsLogin) {
      if (IsUser) {
        GetUserProfile();
      }
      if (IsHostess) {
        GetHostessProfile();
      }
    }
  }, [IsLogin,]);

  const navigateto = (page) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    navigate(`/${page}`)
  }


  return (
    <>
      <nav>
        <Link to='/'>
          <img src={logo} className='nav-logo' alt="Logo" />
        </Link>
        <ul>
          <Link className='none' to='/'>

            <li>Home</li>
          </Link>
          <Link className='none' to='/allmodal'>
            <li>Search</li>

          </Link>
          <Link className='none' to='/howitwoks'>

            <li>How it Works</li>
          </Link>
          <Link className='none' to='/join'>

            <li>Are you a Hostess/Model?</li>
          </Link>
        </ul>
        {/* <ul className='navbtn'>

          <li>
            <div className='nav-list' onClick={toggleMenu}>
              <i style={{ color: 'white' }} class="bi bi-list"></i>
            </div>
          </li>
        </ul> */}
        <div className='new-log'>
  {IsLogin ? (
    // Show profile icon when user is logged in
    <div className="profile-dropdown">
    <i style={{fontSize:'25px', color:'#950952' , cursor:'pointer'}} onClick={toggleMenu}  class="bi bi-person-circle"></i>
      {/* <img 
        src={UserProfile?.profileImage || "default-profile.png"} 
        alt="Profile" 
        className="profile-icon" 
        
      /> */}
      {isMenuOpen && (
        <ul className="dropdown-menu" ref={menuRef}>
          <li onClick={() => navigate('/profile')}>Profile</li>
          <li onClick={Logout}>Logout</li>
        </ul>
      )}
    </div>
  ) : (
    // Show Login and Signup buttons when user is not logged in
    <>
      <Link to="/login">
        <button className="lo-btn">Login</button>
      </Link>
      <Link to="/signup">
        <button className="sign-btn">Signup</button>
      </Link>
    </>
  )}
</div>
      </nav>

      {isMenuOpen && (
        <div className="dropdown-menu" ref={menuRef}>
          <div className="profile-section">
            {IsLogin ? (
              <>
                {IsHostess && (
                  <div className="profile-togg">
                    <img src={HostessProfile?.Gallary[0] || make} alt={HostessProfile?.UserName} />
                    <div>
                      <h3>{HostessProfile?.UserName}</h3>
                      <p>
                        <i className="bi bi-geo-alt">{HostessProfile?.City}</i>
                      </p>
                      <div>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                      </div>
                    </div>
                  </div>
                )}
                {IsUser && (
                  <div className="profile-togg">
                    <div>
                      <h3>{UserProfile?.UserName}</h3>
                      <p>{UserProfile?.Email}</p>
                      <div>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className='new-log'>
                {/* Show Login and Signup buttons when user is not logged in */}
                <Link to="/login">
                  <button className="lo-btn">Login</button>
                </Link>
                <Link to="/signup">
                  <button className="sign-btn">Signup</button>
                </Link>
              </div>
            )}

            <br />
            {IsLogin &&
              <div className="profile-list" onClick={() => { navigateto('profile') }}>
                <Link style={{ textDecoration: "none", color: "black" }}>
                  <h2>Account</h2>
                </Link>
              </div>
            }
            {IsLogin && IsHostess &&
              <div className="profile-list" onClick={() => { navigateto('profile') }}>
                <Link style={{ textDecoration: "none", color: "black" }} >
                  <h2>Reviews</h2>
                </Link>
              </div>
            }
            {IsLogin && IsHostess &&
              <div className="profile-list" onClick={() => { navigateto('profile') }}>
                <Link style={{ textDecoration: "none", color: "black" }} >
                  <h2>Last views</h2>
                </Link>
              </div>
            }
            <div className="profile-list" onClick={() => { navigateto('contact') }}>
              <Link style={{ textDecoration: "none", color: "black" }} >
                <h2>Help & Contacts</h2>
              </Link>
            </div>
            <br />
            <br />

            {/* Show "View Profile" and "Log Out" buttons only if user is logged in */}
            {IsLogin && (
              <div className="profile-btns">
                <Link to="/profile">
                  <button className="profile-view">View Profile</button>
                </Link>
                <button onClick={Logout} className="profile-btns-out">
                  Log Out
                </button>
              </div>
            )}
          </div>
        </div>
      )}


      {isMenuOpen2 && (
        <div className="dropdown-menu" ref={menuRef2}>
          <div className="profile-section">
            <br />
            <div className='profile-list'>
              <Link style={{ textDecoration: 'none', color: 'black' }} to='/'>
                <h2>Home</h2>
              </Link>
            </div>
            <div className='profile-list'>
              <Link style={{ textDecoration: 'none', color: 'black' }} to='/allmodal'>
                <h2>Search</h2>
              </Link>
            </div>
            <div className='profile-list'>
              <Link style={{ textDecoration: 'none', color: 'black' }} to='/howitwoks'>
                <h2>How Its Work</h2>
              </Link>
            </div>
            <div className='profile-list'>
              <Link style={{ textDecoration: 'none', color: 'black' }} to='/join'>
                <h2>Are you Hostess/Model?</h2>
              </Link>
            </div>
            <div className='profile-list'>
              <Link style={{ textDecoration: 'none', color: 'black' }} to='/contact'>
                <h2>Help & Contacts</h2>
              </Link>
            </div>
            <br /><br />
            {
              !IsLogin &&
              <div className='profile-btns'>
                <Link to='/login'>
                  <button className='profile-view'>Login</button>
                </Link>
                <Link to='/signup'>
                  <button className='profile-btns-out'>Signup</button>
                </Link>

              </div>
            }
          </div>
        </div>
      )}

      {isSearchPopupOpen && (
        <div className="search-popup" ref={searchPopupRef}>
          <form className='searchbox' onSubmit={handleSearchSubmit}>
            <input
              type="text"
              placeholder="Search..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              required
            />
            <button type="submit"><i className="bi bi-search"></i>
            </button>
          </form>
        </div>
      )}
    </>
  );
}

export default Navbar;
